<template>
  <div style="padding: 0px; margin: 0px" class="container">
    <el-header :style="{height: screenWidth >= 600? '64px':hei? hei : '56px',background:'#23262A',color:hei?'red':'white'}" class="position_top" v-if="show">
      <!-- <div v-if="phoneMune">
        <div style="height:100%;background:#fff;position:absolute;top:56px;width:calc(100% - 40px);padding:10px 20px;border-top:2px solid rgb(220,220,220);">
          <div v-for="(item,index) in leftNavItems" :key="index" class="phoneMuneItem">
            <div class="ptitle" @click="pactive(item.path)">{{item.name}}</div>
          </div>
        </div>
      </div> -->
      <div class="header" :style="{height: screenWidth >= 600 ?'64px':'64px',justifyContent: screenWidth >= 600 ?'space-between':'space-between',width: screenWidth >1024 ? '1200px': '',margin: screenWidth >= 600 ? 'auto': '',  padding: screenWidth >= 600 ?'none':'0 20px'}">
        <div :style="{lineHeight:screenWidth >= 600? '64px' : '55px', alignItems: 'center' }">
            <img :style="{marginTop: screenWidth >= 600 ?' 4%':'0%',height: screenWidth >= 600 ?' 36px':'30px', width: screenWidth >= 600 ?' 90px':''}" src="../assets/logo.png"/>
        </div>
        <div style="z-index:1000">
          <ul class="myMune" v-if=" screenWidth >= 600">
            <div v-for="(item,index) in navItems" :key="index" @click="active(index,item.path)">
              <div class="menu_item">
                <div class="title" :style="{color: activeIndex == index ? '#3170FF' : ''}">{{item.name}}</div>
                <!-- <div :style="{borderTop:hei?'3px solid #ececec':'none'}"  v-if="indextype === index" >
                  <div v-for="it in item.sub" :key="it.key" @click.stop="toWhere(it.key,item.path)" style="font-size:16px;" :style="{background:hei?'#fff':'none'}" >
                    {{it.name}}
                  </div>
                </div> -->
              </div>
            </div>
          </ul>
          <div v-else @click="showPhone" class="phoneMenu">
            <div><img :style="{height:'15px'}" src="../assets/menu.png"/></div>
          </div>
          <el-drawer
            :visible.sync="drawer"
            direction="rtl"
            size="100%"
            :append-to-body="true"
            >
            <template slot="title">
                <div><img :style="{height:'30px'}" src="../assets/logo.png"/></div>
            </template>
            <div class="menuInfo">
              <div v-for="(item,index) in phoneNavItems" :key="index + 'ts'"  @click="topage(index)">
                {{ item.name }}
              </div>
              <div class="slogan" style="border:none"><img :style="{height:'66px'}" src="../assets/slogan.png"/></div>
            </div>
          </el-drawer>
        </div>
      </div>
    </el-header>
    <el-main id="main" class="main" style="padding: 0px; overflow: auto;height:100%" ref="main">
      <div class="notfind">
        <div style="font-size:60px;">404</div>
      <div style="margin-top:10px;">
        页面找不到啦~
      </div>
      </div>

    </el-main>
  </div>
</template>

<script>
import { EventBus } from '@/untils/eventBus'

  export default {
    name: 'Main',
    data() {
      return {
        drawer:false,
        phoneMune: false,
        activeIndex: 0,
        currentPath: "",
        hei: 0,
        indextype: 10,
        show: true,
        menuMap: {
          "home": 0,
          "product": 1,
          "service": 2,
          "news": 3,
          "aboutUs": 4,
          "joinUs": 5
        },
        screenWidth: document.body.clientWidth,
        icp: "蜀ICP备2020027900号",
        // navItems: [
        //   { name: "关于我们",  index: "6" },
        //   { name: "管控平台",  index: "5" },
        //   { name: "服务与支持",   index: "4" },
        //   { name: "产品中心",  index: "2"},

        //   { name: "首页",  index: "1" },

        // ]
         navItems: [
          { name: "首页",  index: "0" ,path:'/'},
          { name: "产品中心",  index: "1",path:'/product'},
          { name: "解决方案",   index: "2" ,path:'/service'},
          { name: "资讯动态",  index: "3" ,path:'/news'},
          { name: "走进辰鳗",  index: "4" ,path:'/aboutUs'},
          { name: "加入辰鳗",  index: "5" ,path:'/joinUs'},
        ],
        phoneNavItems:[
          { name: "首页"},
          { name: "产品中心"},
          { name: "解决方案"},
          { name: "资讯动态"},
          { name: "走进辰鳗"},
          { name: "加入辰鳗"},
        ],
         timer: 0
      }
    },
    mounted() {
      localStorage.clear()
      let href = window.location.href
      if (href.indexOf("www.chenman360.com") != -1) {
        this.icp = "蜀ICP备2020027900号-1"
      } else if (href.indexOf("www.chenmankeji.com") != -1) {
        this.icp = "蜀ICP备2020027900号-3"
      } else if (href.indexOf("www.smalleel.com") != -1) {
        this.icp = "蜀ICP备2020027900号-2"
      }
      this.navItems.forEach(ele=>{
        if(href.includes(ele.path)){
          this.activeIndex = ele.index
        }
      })

      window.onresize = () => {
        this.screenWidth = document.body.clientWidth
      }
      window.addEventListener('scroll', this.handleScroll,true);  // 监听（绑定）滚轮滚动事件
      window.addEventListener('mousewheel', this.cletimer,true)
      function ok (list){
        let op = []
        for (let index = 0; index < list.length; index++) {
          const element = list[index];
          op.push(element.id)
        }
        return op
      }
      let p = ok([{id:12}])

      EventBus.$on('index',(msg)=> {
        this.activeIndex = msg
      })
    },

    watch: {
      screenWidth(newValue) {
        // 为了避免频繁触发resize函数导致页面卡顿，使用定时器
        if (!this.timer) {
          // 一旦监听到的screenWidth值改变，就将其重新赋给data里的screenWidth
          this.screenWidth = newValue;
          this.timer = true;
          setTimeout(() => {
            //console.log(this.screenWidth);
            this.timer = false;
          }, 400);
        }
      },

    },
    destroyed(){
      window.removeEventListener('scroll', this.handleScroll);
    },
    methods: {
      topage(e){
        switch (e) {
          case 0:
            this.$router.push({path:'/'})
            break;
          case 1:
            this.$router.push({path:'/phoneProduct'})
            break;
          case 2:
            this.$router.push({path:'/phoneService'})
            break;
          case 3:
            this.$router.push({path:'/phoneNews'})
            break;
          case 4:
            this.$router.push({path:'/phoneCloseCM'})
            break;
          case 5:
            this.$router.push({path:'/phoneJoinUs'})
            break;
          default:
            break;
        }
        this.drawer = false
      },
      joinUs(){
        this.$router.push({path:'/aboutUs'})
        document.getElementById('main').scrollTop = 0
      },
      showPhone(){
        this.drawer = true
        // this.phoneMune = !this.phoneMune
      },
      toWhere(key,path){
        this.$router.push({path:path})
        setTimeout(()=>{
          if(key == 'jj'){
            document.getElementById('main').scrollTop = 600
          }
          if(key == 'yjysm'){
            document.getElementById('main').scrollTop = 1100
          }
          if(key == 'qywh'){
            document.getElementById('main').scrollTop = 1650
          }
          if(key == 'cpjs'){
            document.getElementById('main').scrollTop = 500
          }
          if(key == 'jjfa'){
            document.getElementById('main').scrollTop = 3100
          }
          if(key == 'cshbzm'){
            document.getElementById('main').scrollTop = 4700
          }
          if(key == 'gsdt'){
            document.getElementById('main').scrollTop = 650
          }
          if(key == 'mtbd'){
            document.getElementById('main').scrollTop = 1200
          }
          if(key == 'rcln'){
            document.getElementById('main').scrollTop = 550
          }
          if(key == 'zwxx'){
            document.getElementById('main').scrollTop = 1400
          }
          this.hei = 0
          this.indextype = -1
        },500)

      },
      active(index,path){
        this.activeIndex = index
        this.$router.push({path:path})
      },
      pactive(path){
        this.$router.push({path:path})
        this.phoneMune = false
      },
      closeMenu(index){
        this.indextype = -1
        this.hei = 0
      },

       popMenu(index){
        if(index == 1 || index == 2|| index == 3|| index == 4){
          this.hei = '300px'
          this.indextype = index
        }
      },
      cletimer(){
        if(this.timer){
          clearInterval(this.timer)
        }
      },

    }
  }
</script>
<style scoped lang="scss">
@import '../assets/style/main.scss';
 .myMune{
    color: #fff;
    position: relative;
    margin: 0;
    padding-left: 0;
    cursor: pointer;
    font-size: 14px;
  }
  .myMune div{
    list-style: none;
    float: left;
    width: 150px;
    height: 64px;
    font-size: 16px;
    line-height: 64px;
    text-align: center;
    margin: 0;
  }
  .phoneMenu{
    margin-top: 20px;
  }
  .menuInfo div{
    height: 53px;
    border-bottom: 1px solid #E3E7EA;
    margin: 10px;
    line-height: 53px;
    padding: 0 8px;
    font-family: Source Han Sans CN;
    color: #353639;
    font-size: 16px;
    font-family: 'Regular';
  }
  .slogan{
    position: absolute;
    bottom: 4%;
    left: 0%;
    border: none;
  }

  .phone_mune {
    position: absolute;
    top: 10px;
    display: flex;
    width: 80%;
    left: 10%;
    justify-content: space-around;
  }

  .phone_banner {
    position: relative;
    background: rgb(22, 61, 160);
    background-size: 100% 100%;
    height: 200px;
    margin-top: 20px;
  }
  .notfind{

    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
  .container {
    display: flex;
    height: 100%;
    flex-direction: column;
  }

  .el-header {
    /* background-color: #5152E1; */
    height: 70px;
    width: 100%;
    margin: 0px;
    padding: 0px;
    z-index: 100;
  }

  .header {
    display: flex;
    /* justify-content: space-around; */
    /* align-items: center; */
  }

  .el-menu--horizontal > .el-menu-item {
    float: right;
    width: 150px;
    height: 70px;
    font-size: 20px;
    line-height: 70px;
    text-align: center;
    margin: 0;
    /* border-bottom: 2px solid transparent; */
    color: #FFFFFF;
  }

  .el-menu.el-menu--horizontal {
    background-color: transparent;
    border-bottom: solid 0px #5152E1;
    color: #FFFFFF;
  }

  .el-menu.el-menu--horizontal:hover {
    background-color: transparent;
    border-bottom: solid 0px #5152E1;
    color: #FFFFFF;
  }

  .el-menu--horizontal>.el-menu-item:not(.is-disabled):focus{
    background: rgb(224,156,9);
    color: #FFFFFF;
  }
  .el-menu--horizontal > .el-menu-item.is-active {
    border-bottom: 0px solid transparent;
    color: #FFFFFF;
    background: rgb(224,156,9);
  }

  .el-footer {
    padding: 0px;
    background-color: #1745AA;
    height: 200px;
    width: 100%;
  }

  .footer-info {
    background: black;
    background-position: center;
    background-size: cover;
    height: 302px;
    align-items: center;
    margin: auto;
  }

  .footer-bottom {
    /* background-color: #0C3587; */
    height: 60px;
    width: 100%;
    display: flex;
    justify-content: space-between;
  }

  .footerContent {
    width: 1000px;
    margin: auto;
    height: 302px;
    background: black;
  }

  .footer_top{
    width: 1000px;
    margin: auto;
    display: flex;
    flex-direction: column;
  }

  .top_one{
    text-align: left;
    color: #fff;
    padding-top: 20px;
  }

  .alltwo{
    display: flex;
    justify-content: space-between;
  }
  .top_three{
    padding-top: 60px;
    color: #fff;
  }
  .top_two{
    display: flex;
    width: 30%;
    justify-content: space-between;
  }

  .top_two ul{
    list-style: none;
    padding: 0
  }

  .top_two ul>li{
    font-size: 16px;
    color: #fff;
    margin-top: 10px;
    cursor: pointer;
    text-align: left;
  }
  .top_two ul>li:first-child{
    font-size: 18px;
    padding-bottom: 4px;
  }

  /* .qrcode {
    margin-top: 40px;
    margin-left: 120px;
    background-image: url('../assets/qrcode.png');
    background-position: center;
    background-size: cover;
    width: 168px;
    height: 200px;
  } */

  .centerLine {
    width: 40px;
    height: 1px;
    background-color: #9e9e9e;
  }

  .contentTitle {
    padding-top: 15px;
    font-size: 30px;
    letter-spacing: 2px;
  }

  .phoneMuneItem{
    padding: 15px 0;
    border-bottom: 1px solid rgb(220,220,220);
  }

  .phoneMuneItem .ptitle{
    color: rgb(104,104,104);
    text-align: left;
  }

  .contentTitleBack {
    font-size: 16px;
    color: #080000;
    /* line-height: 100px; */
    margin-top: 5px;
    opacity: 0.5;
  }

  .contentItem {
    padding-top: 30px;
    padding-bottom: 20px;
    width: 1280px;
    margin: auto;
  }
  .ten_totop--float:after {
    content: "";
    display: block;
    width: 12px;
    height: 12px;
    position: absolute;
    top: calc(50% - 3px);
    left: calc(50% - 6px);
    transform: rotate(-135deg);
    border-bottom: 1px solid #0052D9;
    border-right: 1px solid #0052D9;
}
.ten_totop--float {
    display: block;
    position: fixed;
    bottom: -200px;
    right: 40px;
    z-index: 98;
    width: 60px;
    height: 60px;
    transition: ease all 0.3s;
    background: #FFF;
    border-radius: 50%;
    border: 1px solid #0052D9;
    cursor: pointer;
    padding: 0px;
}

/* .main {
  height: calc(100vh - 64px);
} */

::-webkit-scrollbar {
    display: none !important
}
</style>



// WEBPACK FOOTER //
// src/components/NotFoundComponent.vue